export default {
    title: 'ការបង្ហោះ WordPress',
    wp: 'WordPress',
    wp_hosting: 'ការបង្ហោះ WordPress',
    wp_hosting_detail: 'ព័ត៌មានលម្អិត WordPress Hosting',
    wp_hosting_info: 'ព័ត៌មាន WordPress ',
    wp_hosting_management: 'ការគ្រប់គ្រង WordPress',
    reinstall_wp: 'ដំឡើង WP ឡើងវិញ',
    server_name: 'ឈ្មោះម៉ាស៊ីនមេ',
    package: 'កញ្ចប់',
    reg_date: 'កាលបរិច្ឆេទ​ចុះឈ្មោះ',
    due_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    auto_renew: 'បន្តដោយស្វ័យប្រវត្តិ',
    server_status: 'ស្ថានភាពម៉ាស៊ីនមេ',
    status: 'ស្ថានភាព',
    upgrade_wordpress_hosting: 'ធ្វើឱ្យប្រសើរឡើង WordPress Hosting',
    upgrade_warning:
        'អ្នក​ត្រូវ​បង់​ប្រាក់​បញ្ជា​ទិញ​នេះ​ក្នុង​មួយ​ថ្ងៃ បើ​មិន​ដូច្នេះ​ទេ​ការ​បញ្ជា​ទិញ​នឹង​ត្រូវ​បាន​លុប',
    package_name: 'មោះកញ្ចប់',
    payment_plan: 'គម្រោងទូទាត់',
    wp_hosting_extend: 'បន្ត​ WordPress Hosting',
    action: 'សកម្មភាព',
    domain: 'ដែន',
    wp_admin: 'អ្នកគ្រប់គ្រង WP',
    name_server: 'ឈ្មោះ​ severs',
    version: 'កំណែ',
    name: 'ឈ្មោះ',
    rating: 'ការវាយតម្លៃ',
    link: 'តំណភ្ជាប់',
    accept_type:
        'សូម​បង្ហាប់​និង​ផ្ទុក​ឡើង​ពួកវា​របស់​អ្នក​នៅ​ក្រោម​ទម្រង់.zip។ ទំហំឯកសារអតិបរមា {size}',
    plugin_accept_type:
        'សូមបង្ហាប់និងផ្ទុកកម្មវិធីជំនួយរបស់អ្នកនៅក្រោម ទម្រង់.zip ។ ទំហំឯកសារអតិបរមា {size}',
    author: 'អ្នកនិពន្ធ',
    management_tab: {
        overview: 'ទិដ្ឋភាពទូទៅ',
        backups: 'ការបម្រុងទុក',
        file_database: 'ឯកសារនិងមូលដ្ឋានទិន្នន័យ',
        themes: 'ផ្ទាំង',
        plugins: 'កម្មវិធីជំនួយ',
        security: 'សន្តិសុខ',
        configuration: 'ការកំណត់​រចនាសម្ព័ន្ធ',
    },
    reinstalling_title: 'គេហទំព័រ WordPress របស់អ្នកកំពុងត្រូវបានដំឡើង។',
    reinstalling_des:
        'គអ្នកនឹងទទួលបានការជូនដំណឹងនៅពេលបញ្ចប់។ សូម​ធ្វើ​ការចចុទំព័រ​ឡើងវិញ​បន្ទាប់​មក',
    reinstall_failed_title: 'ការដំឡើងគេហទំព័រ WordPress របស់អ្នកបានបរាជ័យ',
    reinstall_failed_des:
        'កំហុស មួយ បាន កើត ឡើង ក្នុង អំឡុង ពេល រេញស្ទីល សូម សាក ល្បង ស្តារ ឡើង វិញ ម្ដង ទៀត ។',
    reinstall_warning:
        'ទិន្នន័យទាំងអស់នឹងត្រូវបាត់បង់! ត្រូវប្រាកដថាអ្នកមានការបម្រុងទុកមុនពេលដំឡើងឡើងវិញ',
    reinstall_confirm_message:
        'បន្ទាប់ពីដំឡើងឡើងវិញ ទិន្នន័យ និងការកំណត់ពីមុនទាំងអស់នឹងត្រូវបានលុប',
    reinstall_confirm_question: 'តើអ្នកចង់ដំឡើងឡើងវិញទេ?',
    theme_tab: {
        installed: 'បានដំឡើង',
        add_themes: 'បន្ថែមប្រធានបទ',
        upload_theme: 'បង្ហោះផ្ទាំង',
        active_theme: 'ប្រធានបទសកម្ម',
        inactive_themes: 'ផ្តាំងអសកម្ម',
        search_theme: 'ស្វែងរកផ្ទាំង',
        active_after_upload: 'ធ្វើឱ្យប្រធានបទសកម្មបន្ទាប់ពីផ្ទុកឡើង',
    },
    overview_tab: {
        themes: 'ផ្ទាំង',
        plugins: 'កម្មវិធីជំនួយ',
        up_to_date: 'ទាន់សម័យ',
        updated: 'បានធ្វើបច្ចុប្បន្នភាព',
        out_of_date: 'ថ្ងៃ​ផុតកំណត់',
        overview: 'ទិដ្ឋភាពទូទៅ',
        site_info: 'ព័ត៌មានគេហទំព័រ',
        website_name: 'ឈ្មោះគេហទំព័រ',
        wp_version: 'កំណែ WordPress',
        upgrade_now_tooltip:
            'Upgrade version មួយក្នុងចំណោម version ខាងក្រោម៖ {versions}',
        disk_usage: 'ការប្រើប្រាស់ disk',
        used: 'បានប្រើ',
    },
    configuration: {
        title: 'ការកំណត់​រចនាសម្ព័ន្ធ',
        configs: {
            auto_upgrade_code: {
                title: 'ធ្វើបច្ចុប្បន្នភាពដោយស្វ័យប្រវត្តិ ស្នូល WordPress',
                tooltip:
                    'ជ្រើសរើស​ចំណូលចិត្ត​ធ្វើ​ឱ្យ​ប្រសើរ​ដោយ​ស្វ័យ​ប្រវត្តិ​សម្រាប់​ស្នូល WordPress',
                options: {
                    0: 'កុំដំឡើងកំណែដោយស្វ័យប្រវត្តិ',
                    1: 'ដំឡើង​កំណែ​ទៅ​កំណែ​ចុងក្រោយ​បំផុត​ដែល​អាច​ប្រើ​បាន (Major ក៏​ដូចជា Minor)',
                    2: 'ដំឡើងកំណែទៅកំណែតូចតែប៉ុណ្ណោះ',
                },
            },
            auto_upgrade_themes: {
                title: 'ធ្វើឱ្យទាន់សម័យដោយស្វ័យប្រវត្តិស្បែកប្លក, រូបភាព',
                tooltip:
                    'ប្រសិនបើបើកដំណើរការ ស្បែក WordPress ទាំងអស់សម្រាប់ការដំឡើងនេះនឹងត្រូវបានដំឡើងកំណែដោយស្វ័យប្រវត្តិទៅកំណែចុងក្រោយបំផុត (រៀងរាល់ 24 ម៉ោង)',
            },
            auto_upgrade_plugins: {
                title: 'ដំឡើងកំណែដោយស្វ័យប្រវត្តិកម្មវិធីជំនួយ WordPress',
                tooltip:
                    'ប្រសិនបើបើកដំណើរការ កម្មវិធីជំនួយ WordPress ទាំងអស់ដែលបានដំឡើងសម្រាប់ការដំឡើងនេះនឹងត្រូវបានដំឡើងកំណែដោយស្វ័យប្រវត្តិទៅកំណែចុងក្រោយបំផុត (រៀងរាល់ 24 ម៉ោង)',
            },
            search_engine: {
                title: 'ភាពមើលឃើញរបស់ម៉ាស៊ីនស្វែងរក',
                tooltip:
                    'ប្រសិនបើបើកដំណើរការ គេហទំព័ររបស់អ្នកនឹងត្រូវបានរុករកដោយម៉ាស៊ីនស្វែងរក។ ប្រសិនបើគេហទំព័ររបស់អ្នកកំពុងសាងសង់ អ្នកអាចបិទវា ហើយបើកវានៅពេលដែលគេហទំព័ររបស់អ្នកកំពុងផ្សាយបន្តផ្ទាល់។ លំនាំដើម៖ បានបើក',
            },
            cron: {
                title: 'WordPress Cron (wp-cron.php)',
                tooltip:
                    'ប្រសិនបើបិទ WordPress cron នឹងត្រូវបានបិទ ហើយការងារ cron នឹងត្រូវបានបន្ថែមនៅក្នុងផ្ទាំងបញ្ជារបស់អ្នកដែលត្រូវប្រតិបត្តិពីរដងក្នុងមួយម៉ោង។ លំនាំដើម៖ បានបើក',
            },
            debug: {
                title: 'របៀប​បំបាត់​កំហុស',
                tooltip:
                    'ប្រសិនបើបើកដំណើរការ របៀបកែកំហុស WordPress នឹងត្រូវបានបើក ដែលនឹងជួយអ្នកស្វែងរកមូលហេតុនៃកំហុស ក្នុងករណីមានកំហុសធ្ងន់ធ្ងរ។<br />ចំណាំ៖ កុំទុកវាឱ្យដំណើរការនៅលើគេហទំព័រផលិតកម្ម។ លំនាំដើម៖ បិទ',
            },
        },
    },
    create_backup_section: {
        title: 'ការបម្រុងទុក',
        description: 'បង្កើតការបម្រុងទុកនៃគេហទំព័ររបស់អ្នកជាទៀងទាត់',
        create_backup: 'បង្កើតការបម្រុងទុក',
    },
    modal_backup_wp: {
        title: 'ការបម្រុងទុក WordPress',
        backup_operation: {
            title: 'ជ្រើសរើសប្រតិបត្តិការបម្រុងទុក',
            backup_directory: 'បម្រុងទុកឯកសារ',
            backup_directory_des:
                'ប្រសិនបើអ្នកពិនិត្យមើលវា បញ្ចីទាំងមូលនឹងត្រូវបានបម្រុងទុក',
            backup_database: 'បម្រុងទុកមូលដ្ឋានទិន្នន័យ',
            backup_database_des:
                'ប្រសិនបើអ្នកពិនិត្យមើល​ database អ្នកក៏នឹងត្រូវបានបម្រុងទុកផងដែរ',
            backup_note: 'ចំណាំបម្រុងទុក',
            tooltip_backup_note:
                'អ្នកអាចរក្សាទុកកំណត់ចំណាំសម្រាប់ជាឯកសារយោងរបស់អ្នកបាន។',
        },
        wp_info: {
            title: 'ព័ត៌មាន',
            software: 'Software',
            ins_number: 'លេខដំឡើង',
            version: 'កំណែ',
            url: 'URL',
        },
        in_progress_title: 'ការបម្រុងទុក WordPress ({progressPercent}%)',
        in_progress_des:
            'ចំណាំ៖ វាអាចចំណាយពេល 3-4 នាទី។ អ្នកអាចចាកចេញបានប្រសិនបើអ្នកចង់!',
        backup_done: 'ការបម្រុងទុកត្រូវបានបង្កើតឡើងដោយជោគជ័យ',
    },
    backup_failed: {
        title: 'កំហុសខាងក្រោមត្រូវបានរកឃើញ៖',
        reason1:
            'បរាជ័យក្នុងការសរសេរទៅឯកសារបម្រុងទុក។ សូមពិនិត្យមើលថាអ្នកមាន quote ថាសគ្រប់គ្រាន់។',
        reason2: 'ឧបករណ៍ប្រើប្រាស់បម្រុងទុកមិនអាចបម្រុងទុកឯកសារបានទេ។',
    },
    plugin_tabs: {
        installed: 'បានដំឡើង',
        add_plugins: 'បន្ថែមកម្មវិធីជំនួយ',
        upload_plugin: 'ផ្ទុកកម្មវិធីជំនួយ',
        search_theme: 'ស្វែងរកកម្មវិធីជំនួយ',
        active_after_upload: 'ដំណើរការកម្មវិធីជំនួយបន្ទាប់ពីការបង្ហោះ',
    },
    message: {
        theme_delete_confirm: 'តើអ្នកប្រាកដទេថាចង់លុបរចនាបថ {themeName}?',
        theme_activate_confirm:
            'តើអ្នកប្រាកដជាចង់ធ្វើឱ្យរចនាបថ {themeName} ដំណើរការ?',
        theme_upgrade_confirm: 'តើអ្នកប្រាកដជាចង់ដំឡើងកំណែ {themeName} រចនាបថ?',
        enter_theme: 'សូមបញ្ចូលឈ្មោះផ្ទាំង',
        upload_theme_success: 'ផ្ទាំងត្រូវបានដំឡើងដោយជោគជ័យ',
        enter_plugin: 'សូមបញ្ចូលឈ្មោះកម្មវិធីជំនួយ',
        upload_plugin_success: 'កម្មវិធីជំនួយត្រូវបានដំឡើងដោយជោគជ័យ',
        reinstall_success: 'WordPress របស់អ្នកបានដំឡើងឡើងវិញដោយជោគជ័យ',
        turn_on_ssl_confirm: 'តើអ្នកប្រាកដថាចង់បើកវិញ្ញាបនបត្រ SSL មែនទេ?',
        turn_off_ssl_confirm: 'តើអ្នកប្រាកដថាចង់បិទវិញ្ញាបនបត្រ SSL មែនទេ?',
        turn_on_enforce_https_confirm:
            'តើអ្នកប្រាកដថាចង់បើក Enforce HTTPS មែនទេ?',
        turn_off_enforce_https_confirm:
            'តើអ្នកប្រាកដថាចង់បិទ Enforce HTTPS មែនទេ?',
        revoke_db_account_confirm:
            'តើ​អ្នក​ប្រាកដ​ជា​ចង់​លុប​ចោល​គណនីយ Database ​នេះ​ឬ?',
        revoke_ftp_account_confirm: 'តើអ្នកប្រាកដថាចង់លុបគណនី FTP នេះទេ?',
        restore_backup_confirm: 'តើអ្នកប្រាកដដែរទេថាអ្នកចង់ដំឡើងវាឡើងវិញ?',
    },
    list_backups: {
        title: 'ការបម្រុងទុកពីមុន',
        description: 'ការពិពណ៌នា',
        file_name: 'ឈ្មោះ​ឯកសារ',
        size: 'ទំហំ',
        version: 'កំណែ',
    },
    modal_restore_wp: {
        title: 'ការស្តារ WordPress',
        restore_directory: 'ស្តារថតឯកសារឡើងវិញ',
        restore_directory_des:
            'ប្រសិនបើអ្នកពិនិត្យវា បញ្ជីទាំងមូលនឹងត្រូវបានស្ដារឡើងវិញ',
        delete_files: 'លុបឯកសារ/ថតឯកសារដែលមានស្រាប់',
        delete_files_des:
            'ប្រសិនបើធីកឯកសារ/ថតឯកសារដែលមានស្រាប់នឹងត្រូវបានលុប ហើយបន្ទាប់មកឯកសារបម្រុងទុកនឹងត្រូវបានស្ដារឡើងវិញ។{lineBreak}ចំណាំ៖ សូមប្រាកដថាអ្នកបានជ្រើសរើសការបម្រុងទុកពេញលេញ ខណៈពេលដែលបង្កើតការបម្រុងទុកនេះ។',
        restore_database: 'ស្តារ database',
        restore_database_des:
            'ប្រសិនបើអ្នកពិនិត្យមើលមូលដ្ឋានទិន្នន័យក៏នឹងត្រូវបានស្ដារឡើងវិញផងដែរ។',
        in_progress_title: 'ស្ដារ​ការ​បម្រុង​ទុក ({progressPercent}%)',
        in_progress_des:
            'ចំណាំ៖ វាអាចចំណាយពេល 3-4 នាទី។ អ្នកអាចចាកចេញប្រសិនបើអ្នកចង់!',
        restore_done: 'ការបម្រុងទុករបស់អ្នកត្រូវបានស្ដារឡើងវិញដោយជោគជ័យ',
    },
    installed_plugin_item: {
        version: 'កំណែ',
        upgrade_to_version: 'ដំឡើង​កំណែ​ទៅ​កំណែថ្មី {version}',
        activate_plugin: 'ធ្វើឱ្យកម្មវិធីជំនួយសកម្ម',
        activate_plugin_des:
            'តើអ្នកប្រាកដថាចង់ធ្វើឱ្យកម្មវិធីជំនួយ {pluginName} សកម្មទេ?',
        deactivate_plugin: 'បិទដំណើរការកម្មវិធីជំនួយ',
        deactivate_plugin_des:
            'តើអ្នកប្រាកដថាចង់បិទកម្មវិធីជំនួយ {pluginName} ទេ?',
    },
    file_and_db: {
        access_time: {
            hour_1: 'ចូលប្រើរយៈពេល 1 ម៉ោង។',
            hour_12: 'ចូលប្រើរយៈពេល 12 ម៉ោង។',
            hour_24: 'ចូលប្រើរយៈពេល 24 ម៉ោង។',
        },
        ftp_access: 'ការចូលប្រើ FTP',
        ftp_access_des:
            'ចូលប្រើឯកសារគេហទំព័ររបស់អ្នកតាមរយៈម៉ាស៊ីនភ្ញៀវ FTP ដើម្បីកែសម្រួលកូដគេហទំព័ររបស់អ្នក និងដោះស្រាយបញ្ហាណាមួយ.{lineBreak}យើងណែនាំអ្នកឱ្យធ្វើការបម្រុងទុកមុនពេលផ្លាស់ប្តូរឯកសារណាមួយ។',
        access: 'ការចូលប្រើ',
        expire_time: 'ផុតកំណត់ក្នុងរយៈពេល {expireTime} វិនាទី',
        server: 'ម៉ាស៊ីនមេ',
        port: 'Port',
        username: 'ឈ្មោះ​អ្នកប្រើប្រាស់',
        password: 'ពាក្យសម្ងាត់',
        db_access: 'ការចូលប្រើមូលដ្ឋានទិន្នន័យ',
        db_access_des:
            'ចូលប្រើគេហទំព័រមូលដ្ឋានទិន្នន័យរបស់អ្នកតាមរយៈ phpMyAdmin.{lineBreak}សូមកុំប្រើព័ត៌មានលម្អិតនៃមូលដ្ឋានទិន្នន័យទាំងនេះនៅក្នុងឯកសារកំណត់រចនាសម្ព័ន្ធ WordPress (wp-config.php).{lineBreak}ប្រសិនបើអ្នកត្រូវការព័ត៌មានលម្អិតសម្រាប់ wp-config សូមកុំស្ទាក់ស្ទើរក្នុងការទាក់ទងមកខាងផ្នែកជំនួយការអតិថិជនរបស់យើងខ្ញុំ ។',
        go_to_db_tool: 'ចូលទៅកាន់ PHPMyAdmin',
    },
    reinstall: {
        modal_title: 'កំណត់រចនាសម្ព័ន្ធ WP',
        theme: 'ស្បែក',
        plugins: 'កម្មវិធីជំនួយ',
        warning: {
            title: 'សូមចំណាំការព្រមានខាងក្រោម៖',
            text_1: 'បន្ទាប់ពីការ ស្តារឡើងវិញ រាល់ទិន្នន័យមុនទាំងអស់ ការបម្រុងទុក និងការកំណត់ នឹងត្រូវលុប។',
            text_2: 'ត្រូវ ប្រាកដ ថា អ្នក ទុក បម្រុង ទុក មុន នឹង អនុវត្ត សកម្មភាព នេះ ។',
            go_to_backup: 'ទៅ Backup',
        },
    },
    security: {
        ssl_certificate: {
            title: 'វិញ្ញាបនបត្រ SSL',
            description:
                'SSL ជួយរក្សាព័ត៌មានដូចជាការចូល ពាក្យសម្ងាត់ និងលេខកាតឥណទានរបស់អតិថិជនអោយមានសុវត្ថិភាព។',
        },
        enforce_https: {
            title: 'Enforce HTTPS',
            description:
                'បង្ខំឱ្យមានការតភ្ជាប់ដែលមានសុវត្ថិភាពទៅកាន់គេហទំព័ររបស់អ្នក ដើម្បីផ្តល់នូវបទពិសោធន៍រុករកប្រកបដោយសុវត្ថិភាព និងសុវត្ថិភាពដល់អ្នកទស្សនារបស់អ្នក។',
        },
        verifying_message: 'វិញ្ញាបនបត្រ SSL របស់អ្នកកំពុងត្រូវបានផ្ទៀងផ្ទាត់',
        not_support_ssl:
            'វិញ្ញាបនបត្រ SSL មិនមានសម្រាប់ដែនឥតគិតថ្លៃទេ។ ដើម្បីទទួលបានវិញ្ញាបនបត្រ SSL សូមប្រើដែនផ្ទាល់ខ្លួនរបស់អ្នក',
        ssl_change_time_message:
            'ប្រព័ន្ធកំពុងដំណើរការការកំណត់រចនាសម្ព័ន្ធ SSL របស់អ្នក។',
        ssl_type: {
            none: 'គ្មាន SSL',
            custom: 'SSL ផ្ទាល់ខ្លួន',
            free: 'SSL ឥតគិតថ្លៃ ',
        },
    },
    new_main_domain_name: 'ឈ្មោះdomainសំខាន់ថ្មី',
    new_main_domain_name_placeholder: 'សូមបញ្ចូលឈ្មោះdomainថ្មីរបស់អ្នក',
    new_main_domain_name_warning: {
        title: 'សំខាន់! តើការផ្លាស់ប្តូរនេះមានន័យយ៉ាងណា',
        text_1: {
            title: 'ស្ទួនឈ្មោះ Domain',
            content:
                'Domain name សំខាន់ថ្មីរបស់អ្នកមិនគួរមាននៅក្នុងគណនីបង្ហោះ WordPress 1Byte ផ្សេងទៀតទេ',
        },
        text_2: {
            title: 'ការធ្វើការ updates ដោយស្វ័យប្រវត្តិ',
            content:
                'មាតិកា/ឯកសារណាមួយ អ៊ីមែល និងគណនី FTP នឹងត្រូវបានចាត់តាំងឡើងវិញពីឈ្មោះdomainពីមុនរបស់អ្នកទៅកាន់គណនីថ្មីមួយរបស់អ្នក',
        },
        text_3: {
            title: 'តម្រូវឱ្យធ្វើការ updates ដោយដៃ',
            content:
                'ទោះយ៉ាងណាក៏ដោយ ការដំឡើងកម្មវិធី Softaculous និងការបម្រុងទុករបស់ពួកវានឹងមិនត្រូវបានចាត់តាំងឡើងវិញពីឈ្មោះដែនពីមុនរបស់អ្នកទៅកាន់ឈ្មោះថ្មីរបស់អ្នកទេ។ វាគួរតែត្រូវបានអាប់ដេតដោយផ្ទាល់',
        },
    },
    new_main_domain_error:
        'វាហាក់ដូចជាឈ្មោះdomainនេះត្រូវបានហាមឃាត់ មានរួចហើយ ឬមានពាណិជ្ជសញ្ញា',
    understand_and_agree: 'ខ្ញុំយល់និងយល់ព្រម',
    modal_upgrade_wp_version: {
        title: 'ការអាប់ដេត WordPress',
        in_progress_title: 'ការអាប់ដេត WordPress ({progressPercent}%)',
        in_progress_des:
            'ចំណាំ៖ វាអាចចំណាយពេល 3-4 នាទី។ អ្នកអាចចាកចេញបានប្រសិនបើអ្នកចង់!',
        upgrade_done: 'WordPress ត្រូវបានអាប់ដេតដោយជោគជ័យ',
        create_backup: 'បង្កើតការបម្រុងទុក',
        create_backup_des: 'បង្កើតការបម្រុងទុកមុនពេលធ្វើការអាប់ដេត',
        select_a_version: 'ជ្រើសរើស​ version ​ដើម្បី​ធ្វើការអាប់ដេត',
        backup_option: 'ជម្រើសនៃការ Backup ',
        backup_option_des: 'ជ្រើសរើសជម្រើស back up ពេញលេញ ឬកម្រិតខ្ពស់',
        backup_full: 'Backup ពេញលេញ (Default)',
        backup_advanced: 'ជម្រើស​កម្រិត​ខ្ពស់',
        backup_dir: 'បម្រុងទុកឯកសារ',
        backup_db: 'បម្រុងទុកមូលដ្ឋានទិន្នន័យ',
        upgrade_note:
            '{noteBold}៖ កម្មវិធីនេះនឹងធ្វើការអាប់ដេតដោយប្រើឧបករណ៍ប្រើប្រាស់ក្នុងការអាប់ដេតរបស់វា។​ ដើម្បីបញ្ចប់ការអាប់ដេត សូមចូលទៅកាន់ URL ដែលបង្ហាញនៅពេលឯកសារត្រូវបានចម្លង។​ {lineBreak}{lineBreak}វាត្រូវបានណែនាំអោយអ្នកធ្វើការ backup ទុកនៃការដំឡើងមុនពេលធ្វើបច្ចុប្បន្នភាព។',
    },
    hosting_package: 'កញ្ចប់​ WordPress Hosting',
    modal_update_domain: {
        free_domain: 'ផ្តល់ជូន ឈ្មោះដែន ឥតគិតថ្លៃ',
        new_domain: 'ឈ្មោះដែនថ្មី',
    },
    subdomain_placeholder: 'សូមបញ្ចូលឈ្មោះដែនរង',
    warning_out_date_fpt_domain:
        'FTP និង phpMyAdmin URL របស់អ្នក ហួសសុពលភាពហើយ។ {ចុចនៅទីនេះ} សម្រាប់ព័ត៌មានថ្មីៗ។ ការអាប់ដេតនេះនឹងផ្ទៀងផ្ទាត់ SSL ម្តងទៀត',
    new_domain_form_not_support_ssl:
        'សូមចំណាំ វិញ្ញាបនបត្រ SSL មិនមានសម្រាប់ដែនឥតគិតថ្លៃទេ។ ',
    change_password: 'ប្តូរពាក្យសម្ងាត់របស់ WordPress Hosting',
    change_ssl_certificate: {
        modal_title: 'ផ្លាស់ប្តូរវិញ្ញាបនបត្រ SSL',
        options: {
            no_ssl: 'មិនមានវិញ្ញាបនបត្រ SSL ទេ',
            free_ssl: 'វិញ្ញាបនបត្រ SSL ឥតគិតថ្លៃ',
            custom_ssl: 'រៀបចំវិញ្ញាបនបត្រ SSL ផ្ទាល់ខ្លួន',
        },
        custom_ssl_description:
            'អនុញ្ញាតឲ្យគេហទំព័ររបស់អ្នក ដំណើរការរលូនរវាង browser និង server របស់អ្នក។ ដើម្បីដំណើរការវាបាន សូមបង្ហោះនូវ files ដែលទាមទារ ខាងក្រោម',
        custom_ssl: {
            ssl_certificate: {
                label: 'វិញ្ញាបនបត្រ SSL',
                placeholder: 'បញ្ចូលវិញ្ញាបនបត្រ SSL',
            },
            private_key: {
                label: 'ពាក្យសម្ងាត់ផ្ទាល់ខ្លួន',
                placeholder: 'បញ្ចូលពាក្យសម្ងាត់ផ្ទាល់ខ្លួន',
            },
            ca_bundle: {
                label: 'កញ្ចប់ CA  (អាចរំលងបាន)',
                placeholder: 'បញ្ចូលកញ្ចប់ CA',
            },
        },
    },
    new_domain_form_support_ssl:
        'សូមចំណាំ៖ វិញ្ញាបនបត្រ SSL ឥតគិតថ្លៃនឹងត្រូវបានអនុវត្តចំពោះឈ្មោះដែនថ្មី',
};
